<div class="container mt-5">
  <div *ngIf="authService.decodedToken">
    Welcome to Dance Wyse!<br />
  </div>
  <app-lessonPlans *ngIf="this.isRegistered"></app-lessonPlans>
  <div *ngIf="!this.isRegistered">
    You must log in before you can view any Lesson Plans.
  </div>
</div>